import React, { useState } from 'react';
import { ICreateSpotlightFormikValues } from './types';
import { useQueryBackgrounds } from 'lib/api/backgrounds/useQueryBackgrounds';
import { AddBackgroundModal } from '../../aiAssistants/backgrounds/modals/AddBackgroundModal';
import { useCreateSpotlightMutation } from 'lib/api/spotlight/useCreateSpotlightMutation';
import { errorToast } from 'lib/components/toasts/error';
import { AISpotlightForm } from './forms/AISpotlightForm';
import { useHistory } from 'react-router';
import { mapFolderToOption } from 'lib/utils/folders';
import { DEFAULT_FOLDER } from 'lib/const/Folders';
import { useAuth } from 'lib/context';
import { useTranslation } from 'react-i18next';
import { useQueryCustomerAvatars } from 'lib/api/avatars/customerAvatars/useQueryCustomerAvatars';
interface ICreateSpotlightModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateAISpotlightModal = ({
  isOpen,
  onClose,
}: ICreateSpotlightModalProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { userData } = useAuth();
  const [showBackgroundUploadModal, setShowBackgroundUploadModal] =
    useState(false);

  const toggleShowBackgroundUploadModal = () => {
    setShowBackgroundUploadModal(prev => !prev);
  };

  // Fetch backgrounds
  const {
    data: backgrounds,
    isLoading: isLoadingBackgrounds,
    isFetching: isFetchingBackgrounds,
  } = useQueryBackgrounds();
  const defaultBackgroundId =
    backgrounds?.find(bg => !!bg.default)?.backgroundId || 0;

  // Fetch avatars
  const {
    data: avatars,
    isLoading: isLoadingAvatars,
    isFetching: isFetchingAvatars,
  } = useQueryCustomerAvatars();
  const defaultAvatar = avatars?.find(avatar => !!avatar.default);

  // Create AI Spotlight modal
  const onCreateSpotlightSuccess = (uploadedVideoId: number) => {
    const targetFolder = mapFolderToOption(DEFAULT_FOLDER, userData.id, t);
    history.push({
      pathname: '/review-videos',
      state: {
        videos: [uploadedVideoId],
        targetFolder,
        title: t('Add AI Flex Video'),
        showCounter: false,
        saveText: t('Save Changes'),
      },
    });
    onClose();
  };

  // Create Spotlight Mutation
  const { mutateAsync: createSpotlightMutation } = useCreateSpotlightMutation(
    onCreateSpotlightSuccess
  );

  const onSave = async (values: ICreateSpotlightFormikValues) => {
    if (values.backgroundId === 0) {
      errorToast({ title: t('Please select a background before proceeding.') });
      return;
    }
    const submitValues = {
      script: values.text,
      backgroundId: values.backgroundId?.toString(),
    };
    await createSpotlightMutation(submitValues);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <AISpotlightForm
        onSave={onSave}
        onClose={onClose}
        backgrounds={backgrounds || []}
        defaultBackgroundId={defaultBackgroundId}
        defaultAvatar={defaultAvatar}
        isLoading={isLoadingBackgrounds || isLoadingAvatars}
        toggleShowBackgroundUploadModal={toggleShowBackgroundUploadModal}
        isFetchingBackgrounds={isFetchingBackgrounds || isFetchingAvatars}
      />
      <AddBackgroundModal
        isOpen={showBackgroundUploadModal}
        onClose={toggleShowBackgroundUploadModal}
      />
    </>
  );
};
